import {
  getComplianceCategoryId,
  getComplianceDescriptionId,
} from './organizationComplianceListUtils';

export const _setCplId = (state, action) => {
  state.cplId = action.payload;
};

export const _setCplOrgId = (state, action) => {
  state.cplOrgId = action.payload;
};

export const _setReferenceNumber = (state, action) => {
  state.ReferenceNumber = action.payload;
};

export const _setComplianceCategoryId = (state, action) => {
  state.complianceCategoryId = action.payload;
  state.complianceDescriptionId = getComplianceDescriptionId(
    state.complianceCategoryId
  );
};

export const _setComplianceDescriptionId = (state, action) => {
  state.complianceDescriptionId = action.payload;
  state.complianceCategoryId = getComplianceCategoryId(
    state.complianceDescriptionId
  );
};

export const _setDescription = (state, action) => {
  state.description = action.payload;
};

export const _setStartDate = (state, action) => {
  state.startDate = action.payload;
};

export const _setEndDate = (state, action) => {
  state.endDate = action.payload;
};
